module.exports = __webpack_public_path__ + "static/media/fi-rr-angle-down.68ce9d2f.svg";